<form *ngIf="form" [formGroup]="form">

  <mat-form-field appearance="outline" class="app-block">
    <mat-label i18n>HORIZONTAL COLLECTIVE</mat-label>
    <input matInput formControlName="min_collective_horiz">
    <mat-hint i18n>Minimum number of units to be classified as horizontal collective property</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="app-block">
    <mat-label i18n>VERTICAL COLLECTIVE</mat-label>
    <input matInput formControlName="min_collective_vert">
    <mat-hint i18n>Minimum number of units to be classified as vertical collective property</mat-hint>
  </mat-form-field>

  <mat-action-row>
    <button mat-raised-button (click)="save()" [disabled]="!form.valid" i18n>SAVE</button>
  </mat-action-row>
</form>
